import React from "react";
import ZoomContainer from "./ZoomContainer";
import "./Zoom.css";

class Zoom extends React.Component {
  render() {
    return (
      <div className="zoom">
        <ZoomContainer handleCloseZoom={this.props.handleZoom} />
      </div>
    );
  }
}

export default Zoom;
